export * from './modal-accompanying-document.component'